import React from "react";
import "./CdlContainer.css"; // Import the CSS file

const CdlContainer = () => {
  return (
    <div className="host-signup-container">
      {/* Left Side - Vertical "HOST" and Text Content */}
      <div className="host-text-content">
        <h1 className="vertical-text">HOST</h1>

        <h4 className="text-success cdltxt">Have a CDL?</h4>
        <h2>
          Sign up as a RideHire Operator and Connect 1000's of Vehicle Owners
          Looking to connect with professional chauffeurs.
        </h2>
        <p>
          Create an account, set your availability, and accept offers to browse
          jobs from members in our network. Build your reputation and become a
          sought-after service provider.
        </p>

        <button className="btn btn-success">Become a Host</button>
      </div>

      {/* Right Side - Overlapping Images with Green Shape */}
      <div className="host-image-content">
        <img
          src={require("../Assests/Group 341.png")}
          alt="Decorative Shape"
          className="decorative-shape"
        />
       
      </div>
    </div>
  );
};

export default CdlContainer;
